'use strict';

var ProfileChartNextPrevButtonsDirective = function ProfileChartNextPrevButtonsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/profile-chart-next-prev-buttons.html'),
    controller: 'ProfileChartNextPrevButtonsController',
    link: function link() {}
  };
};
ProfileChartNextPrevButtonsDirective.$inject = [];
module.exports = ProfileChartNextPrevButtonsDirective;